import { ChainID, Timeframe } from '@ankr.com/chains-list';
import { ETelemetryTopOf } from 'multirpc-sdk';
import { useMemo } from 'react';

import { IUsePrivateStatsProps } from 'modules/stats/hooks/usePrivateStats';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';

import { mapChainIdToPath } from '../utils/mapChainIdToPath';
import { chainsTimeframeToStatsTimeframeMap } from '../constants';

export interface IUsePrivateStatsParams {
  chainId?: ChainID;
  metrics: ETelemetryTopOf[];
  timeframe: Timeframe;
}

export const usePrivateStatsParams = ({
  chainId,
  metrics,
  timeframe,
}: IUsePrivateStatsParams) => {
  const { group, isAccountInitializing, workerToken } = useAccount();

  const { jwts, loading: jwtsLoading } = useJWTs({ group, skipFetching: true });
  const hasJWTs = jwts.length > 0;

  const blockchains = useMemo(
    () => (chainId ? [mapChainIdToPath(chainId)] : undefined),
    [chainId],
  );
  const skipFetching = !hasJWTs || jwtsLoading || isAccountInitializing;

  const privateStatsParams = useMemo(
    (): IUsePrivateStatsProps => ({
      blockchains,
      metrics,
      timeframe: chainsTimeframeToStatsTimeframeMap[timeframe],
      skipFetching,
      workerToken: workerToken!,
    }),
    [blockchains, metrics, skipFetching, timeframe, workerToken],
  );

  return { privateStatsParams };
};
